import React from "react";

import { SelectEntityByType } from "../../modules/SelectEntityByType/SelectEntityByType";
import { FiltersFieldsTypes } from "../../modules/SelectEntityByType/constants";

export const DataSelectorTypesField = ({ className, name = "type_code", label = "Selector Type", ...restProps }) => (
    <SelectEntityByType
        className={className}
        name={name}
        FieldsTypes={FiltersFieldsTypes.dataSelectorType}
        label={label}
        {...restProps}
    />
);
